/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable accessor-pairs */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { CanvasContext } from "@tarojs/taro";

export default class WxCanvas {
  private ctx: CanvasContext;

  private chart: any;

  private canvasNode: any;

  private event: {};

  constructor(ctx: CanvasContext, isNew: boolean, canvasNode?: any) {
    this.ctx = ctx;
    this.chart = null;
    if (isNew) {
      this.canvasNode = canvasNode;
    } else {
      this._initStyle(ctx);
    }

    this._initEvent();
  }

  getContext(contextType) {
    if (contextType === "2d") {
      return this.ctx;
    }
  }

  setChart(chart) {
    this.chart = chart;
  }

  attachEvent() {
    // noop
  }

  addEventListener() {
    // noop
  }

  removeEventListener() {
    // noop
  }

  detachEvent() {
    // noop
  }

  _initCanvas(zrender, ctx) {
    zrender.util.getContext = function () {
      return ctx;
    };

    zrender.util.$override("measureText", function (text, font) {
      ctx.font = font || "12px sans-serif";
      return ctx.measureText(text);
    });
  }

  _initStyle(ctx) {
    let styles = [
      "fillStyle",
      "strokeStyle",
      "globalAlpha",
      "textAlign",
      "textBaseAlign",
      "shadow",
      "lineWidth",
      "lineCap",
      "lineJoin",
      "lineDash",
      "miterLimit",
      "fontSize",
    ];

    styles.forEach(style => {
      Object.defineProperty(ctx, style, {
        set: value => {
          if (
            (style !== "fillStyle" && style !== "strokeStyle") ||
            (value !== "none" && value !== null)
          ) {
            ctx["set" + style.charAt(0).toUpperCase() + style.slice(1)](value);
          }
        },
      });
    });

    ctx.createRadialGradient = function () {
      return ctx.createCircularGradient.apply(ctx, arguments);
    };
  }

  _initEvent() {
    this.event = {};
    const eventNames = [
      {
        wxName: "touchStart",
        ecName: "mousedown",
      },
      {
        wxName: "touchMove",
        ecName: "mousemove",
      },
      {
        wxName: "touchEnd",
        ecName: "mouseup",
      },
      {
        wxName: "touchEnd",
        ecName: "click",
      },
    ];

    eventNames.forEach(name => {
      this.event[name.wxName] = e => {
        const touch = e.touches[0];
        if (this.chart) {
          this.chart.getZr()?.handler?.dispatch(name.ecName, {
            zrX: name.wxName === "tap" ? touch.clientX : touch.x,
            zrY: name.wxName === "tap" ? touch.clientY : touch.y,
          });
        }
      };
    });
  }

  set width(w) {
    if (this.canvasNode) this.canvasNode.width = w;
  }

  set height(h) {
    if (this.canvasNode) this.canvasNode.height = h;
  }

  // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
  get width() {
    if (this.canvasNode) return this.canvasNode.width;
    return 0;
  }

  // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
  get height() {
    if (this.canvasNode) return this.canvasNode.height;
    return 0;
  }
}
